// extracted by mini-css-extract-plugin
export default {"thanks":"Thanks_thanks__CNyWr","thanks__title":"Thanks_thanks__title__52C0p","thanks__text":"Thanks_thanks__text__q84TB"};